<template>
  <article class="item" v-on="$listeners">
    <a
      :href="notification.target_url"
      class="link"
      data-test-id="notifications-item-link"
      rel="noopener"
      @click="onClick"
    >
      <img
        v-if="!fallbackVisible"
        v-lazy="{ src: notification.image_url }"
        class="image"
        alt=""
      >
      <LogoColor v-else class="image" />
      <p class="text" data-test-id="notifications-item-text">
        <span v-safe-html="notificationText" />
        <time
          v-if="dateVisible"
          :datetime="notification.publish_date"
          class="date"
          data-test-id="notifications-item-date"
        >
          {{ formattedDate }}
        </time>
      </p>
    </a>
  </article>
</template>

<script>
import { DateTime } from 'luxon';

import { sendEvent } from '~~/common/js/client/analytics';
import LogoColor from '~~/common/vue/components/logos/logo-ecosia-color.svg';

export default {
  name: 'ENotificationItem',
  components: {
    LogoColor,
  },
  props: {
    locale: {
      type: String,
      required: true,
    },
    notification: {
      type: Object,
      required: true,
    },
    eventOrigin: {
      type: String,
      required: true,
    },
    dateVisible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      fallbackVisible: false,
    };
  },
  computed: {
    formattedDate() {
      return this.dateVisible ?
        DateTime.fromISO(this.notification.publish_date).toRelative() :
        '';
    },
    notificationText() {
      return this.notification.text.replace(/<(?!\/?strong)[^>]+>/g, '');
    },
  },
  beforeMount() {
    this.handler = ({ src }) => {
      if (src === this.notification.image_url) {
        this.fallbackVisible = true;
      }
    };
    this.$Lazyload.$on('error', this.handler);
  },
  beforeDestroy() {
    this.$Lazyload.$off('error', this.handler);
  },
  methods: {
    onClick() {
      sendEvent('all_notification_click', {
        origin: this.eventOrigin,
        level: this.notification.level,
        trackingname: this.notification.tracking_name,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  width: 385px;
  font-size: $font-s;
}

.link {
  display: flex;
  position: relative;
  padding: 0;
  transition: background-color $timing-2s $easing;
  background-color: $white;

  &,
  &:visited {
    color: $gray-60;
  }

  &:hover,
  &:focus {
    background-color: $aqua-10;
  }
}

.image {
  height: $space-5l - $space-1s;
  width: $space-5l - $space-1s;
  min-width: $space-5l - $space-1s;
  background-size: contain;
  background-color: $gray-10;
  border-radius: $border-radius-s;
  margin: $space-1s 0 $space-1s $space-1s;
}

.text {
  display: block;
  max-height: $space-4l + $space-l + $space-1s;
  padding: $space-s $space-l 0 $space-s;
  margin: 0;
  hyphens: auto;
  line-height: $line-height-s;
}

.date {
  display: block;
  font-size: $font-1s;
  color: $color-text-secondary;
  margin-top: $space-s;
}
</style>
